"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preparePromo = void 0;
const preparePromo = (method, linkedPromos) => {
  return {
    name: method.dialog.promoName,
    description: method.dialog.promoDescription,
    mortgageLegalInfo: method.dialog.promoLegalTerms,
    authorName: method.dialog.formattedProviderName || '',
    authorLogo: method.provider?.logo || '',
    labels: method.dialog.labels,
    banks: method.dialog.banks.map(bank => ({
      name: bank.name,
      logoUrl: bank.logo
    })),
    features: method.dialog.promoProps.map(prop => ({
      name: prop.title,
      value: prop.value,
      valueChange: prop.valueChange,
      type: prop.type
    })),
    linkedPromos: prepareLinkedPromosSection(method, linkedPromos),
    availableJks: [],
    availablePurchaseTerms: [],
    cianMortgageButton: method.dialog.button,
    creditTerms: method.dialog.creditTerms
  };
};
exports.preparePromo = preparePromo;
function prepareLinkedPromosSection(method, linkedPromos) {
  if (!method.dialog.linkedPromos) {
    return undefined;
  }
  return {
    title: method.dialog.linkedPromos.title || '',
    subtitle: method.dialog.linkedPromos.subtitle,
    promos: method.dialog.linkedPromos.promoIds.reduce((acc, promoId) => {
      const promo = linkedPromos.find(p => p.id === promoId);
      if (!promo) {
        return acc;
      }
      acc.push(promo);
      return acc;
    }, [])
  };
}